import _ from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import { withRouter, Link, routerShape } from 'react-router';
import { connect } from 'react-redux';
import {
  Heading,
  Section,
  Text,
  Divider,
} from 'rebass';
import relativeDate from 'relative-date';
import { Box } from 'reflexbox';

import { selectors } from 'frontend/state/reducers/simbot/jobs';
import { selectors as archivedJobsSelectors } from 'frontend/state/reducers/simbot/archivedJobs';
import { selectors as userSelector } from 'frontend/state/reducers/user';

import If from 'frontend/components/If';

const JobItem = withRouter(({ job, onJobClick, router }) => {
  const jobUrl = `/simbot/report/${job.simId}`;
  const isBeingViewed = jobUrl === router.location.pathname;
  return (
    <Box key={job.simId}>
      <Box>
        {/* eslint-disable jsx-a11y/anchor-is-valid */}
        <Link to={jobUrl} onClick={onJobClick}>
          <Text bold={isBeingViewed}>
            <If
              condition={isBeingViewed}
              then={() => <span>&raquo;&nbsp;</span>}
            />
            {job.title}
          </Text>
        </Link>
        {/* eslint-enable jsx-a11y/anchor-is-valid */}
      </Box>
      <Box pl={1}>
        <If condition={job.type !== 'advanced'}>
          <Text small>
            <strong>{_.startCase(job.player)}</strong>
            {' - '}
            {_.startCase(job.class)}
            {' - '}
            {_.startCase(job.spec)}
          </Text>
        </If>
        <If condition={job.type === 'advanced'}>
          <Text small>
            Advanced
          </Text>
        </If>
      </Box>
      <Box pl={1}>
        <Text small>
          {job.fightStyle} {job.enemyCount > 1 && `(${job.enemyCount})`}
          {' - '}
          {_.startCase(job.simcVersion)}
          {' - '}
          {/* .when is an older variable that might be in some browser localstorage */}
          {job.created ? relativeDate(new Date(job.created)) : relativeDate(job.when)}
        </Text>
      </Box>
      <If
        condition={job && job.dps}
        then={() => (
          <Box pl={1}>
            <Text small>
              {job.dps.toLocaleString()} DPS
            </Text>
          </Box>
        )}
      />
      <Divider mb={1} mt={0} />
    </Box>
  );
});

JobItem.propTypes = {
  job: PropTypes.shape({
    title: PropTypes.string,
    simId: PropTypes.string,
    created: PropTypes.string, // date string
    when: PropTypes.number,
  }).isRequired,
  onJobClick: PropTypes.func.isRequired,
  router: routerShape,
};

const JobList = ({ isLoggedIn, jobs, archivedJobs, onJobClick }) => {
  const sortedJobs = _.sortBy(jobs, 'created');
  const sortedArchivedJobs = _.sortBy(archivedJobs, 'created');
  return (
    <Section mt={0} pt={0}>
      <Heading level={3} mb={1}>Reports</Heading>
      {isLoggedIn
        ? (
          <Box>
            {sortedJobs && sortedJobs.length > 0
              ? (
                <div>
                  {sortedJobs.map(job => (
                    <JobItem key={job.simId} job={job} onJobClick={onJobClick} />
                  )).reverse()}
                  <br />
                </div>
              ) :
                <Text>No reports yet! Go run one!</Text>}
          </Box>
        ) :
          <Text>Create an account to save reports</Text>}
      {sortedArchivedJobs && sortedArchivedJobs.length > 0
        ? (
          <Box mt={3}>
            <Heading level={3}>Obsolete Reports</Heading>
            <Text small>
              Reports from alpha and early beta of Raidbots. These will
              be deleted in the future.  Save a copy if you want an archive.
            </Text>
            <Box mt={1}>
              {sortedArchivedJobs.map(job => (
                <JobItem key={job.simId} job={job} onJobClick={onJobClick} />
              )).reverse()}
            </Box>
          </Box>
        ) :
        null}
    </Section>
  );
};

JobList.propTypes = {
  jobs: PropTypes.arrayOf(PropTypes.object),
  archivedJobs: PropTypes.arrayOf(PropTypes.object),
  onJobClick: PropTypes.func,
  isLoggedIn: PropTypes.bool,
};
JobList.defaultProps = {
  jobs: [],
  archivedJobs: [],
  onJobClick: () => {},
  isLoggedIn: false,
};
JobList.displayName = 'JobList';

const mapStateToProps = state => ({
  jobs: selectors.jobs(state),
  archivedJobs: archivedJobsSelectors.archivedJobs(state),
  isLoggedIn: userSelector.isLoggedIn(state),
});

export default connect(mapStateToProps)(JobList);
